import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ModalYesNo from './CartonisedModalYesNo'
import ModalYesNoWithComment from './CartonisedModalYesNoWithComment'
import ModalOK from './CartonisedModalOk'
import { DashLg, Thunderbolt } from 'react-bootstrap-icons';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import { User } from 'oidc-client';
import * as MySound from '../MySound';
import { stringInsert } from '@devexpress/analytics-core/analytics-internal';

export class CartonisedScanCarton extends Component {
    static displayName = CartonisedScanCarton.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedShipment: props.location.state.selectedShipment,
            alertMessage: "",
            SSCC: "",
            cartonDetail: null,
            cartonAsUOT: false,
            cartonState: "GOOD",
            devanLocationScan: "",
            expectedDevanLocation: "",
            alertAddUkCartonToShipment: false,
            alertCompleteDevanning: false,
            alertDevanToWithScanToteCompare: false,
            alertDevanToWithScanToteCompareMsg: '',
            alertResetForm: false,
            alertExitForm: false,
            unknownCartonList: [],
            unknownCarton: false,
            visibleUnshippableCheckBox: true,
            visibleDamageCheckBox: true,
            visibleCartonAsUOTCheckBox: false,
            disableDevanScanLocation: true,
            disableSSCCInputScan: false,
            disableCartonState: true,
            showScanMessage: false,
            scanMessageTitle: "",
            scanMessage: "",
            isNewToteLocation: false,
            devanCartonScanResultColor: '',
            devanCartonScanResult: '',
            devanErrorAlertFlag: false,
            devanErrorAlertMessage: '',
            unknownCartonComment: '',
            unshippableSelected: ''
        };
        this.history = props.history;

    }
    componentDidMount() {
        //window.history.pushState(null, document.title, window.location.href);
        //window.addEventListener('popstate', function (event) {
        //    window.history.pushState(null, document.title, window.location.href);
        //});
        this.refs.ssccBarcodeScanInput.focus();
    }


    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        let progress = this.state.loading
            ? <p><em>Loading...</em></p>
            : "";
        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        const handleSSCCScan = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.scanCarton();
            }
        };
        const handleDevanLocationScan = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.compareDevanToWithScanTote();
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
        return (
            <>
                {alertMessage}
                {progress}
                <>
                    <h4>Scan Carton</h4>
                    <Row>
                        <Col className="col-4">Shipment:</Col>
                        <Col>{this.state.selectedShipment.shipment_ref}</Col>
                        <Col><Button variant="warning" disabled={this.state.loading} onClick={() => { this.setState({ alertResetForm: true }) }}>Reset</Button></Col>

                    </Row>
                    <Row className="mt-1">
                        <Col className="col-4">
                            Scan SSCC:
                        </Col>
                        <Col className="col-md-8 col-sm-8  col-8">
                            <input autoFocus="autofocus" className="form-control" type="text" placeholder="Scan carton label..."
                                value={this.state.SSCC} onKeyPress={handleSSCCScan} disabled={this.state.disableSSCCInputScan}
                                ref="ssccBarcodeScanInput"
                                onChange={(e) => {
                                    this.setState({ SSCC: e.target.value });
                                }}
                                onInput={toInputUppercase} />
                        </Col>

                    </Row>
                    <Row>
                        <Col className="col-4">Account:</Col>
                        {this.state.cartonDetail !== null && <Col>{this.state.cartonDetail.client_namecode}</Col>}
                    </Row>
                    <Row>
                        <Col className="col-4">Sort Key:</Col>
                        {this.state.cartonDetail !== null && <Col><label>{this.state.unshippableSelected.length===0? this.state.cartonDetail.sort_key: this.state.unshippableSelected}</label></Col>}
                    </Row>
                    <Row>
                        <Col className="col-4">Cartons:</Col>
                        {this.state.cartonDetail !== null && <Col>{this.state.cartonDetail.sort_key_scanned_carton_count}/{this.state.cartonDetail.sort_key_total_carton_count}</Col>}
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            Carton State:
                        </Col>
                        <Col>
                            <Form.Check label="Good" name="group1" type='radio' id='good' disabled={this.state.disableCartonState} defaultChecked
                                ref="chkGood"
                                onClick={(e) => {
                                    if (e.target.checked) {
                                        var devanLocation = "";
                                        if (this.state.cartonDetail.sort_key === "UNKNOWN") {
                                            devanLocation = this.state.cartonDetail.exceptions_location
                                        }
                                        else {
                                            devanLocation = this.state.cartonDetail.devan_location;
                                        }
                                        this.setState({ cartonState: "GOOD", expectedDevanLocation: this.state.cartonDetail.devan_location, unshippableSelected: "" });
                                        this.refs.devanLocationScanInput.focus();

                                    }
                                }}
                            />
                            {this.state.visibleDamageCheckBox && <Form.Check label="Damaged" name="group1" type='radio' id='damaged' disabled={this.state.disableCartonState}
                                ref="chkDamaged"
                                onClick={(e) => {
                                    if (e.target.checked) {
                                        var devanLocation = "";
                                        if (this.state.cartonDetail.sort_key === "UNKNOWN") {
                                            devanLocation = this.state.cartonDetail.exceptions_location
                                        }
                                        else {
                                            devanLocation = this.state.cartonDetail.devan_location;
                                        }
                                        this.setState({ cartonState: "DAMAGED", expectedDevanLocation: devanLocation, unshippableSelected: "" });
                                        this.refs.devanLocationScanInput.focus();
                                    }
                                }}
                            />}
                            {this.state.visibleUnshippableCheckBox && <Form.Check label="Unshippable" name="group1" type='radio' id='unshippable' disabled={this.state.disableCartonState}
                                ref="chkUnshippable"
                                onClick={(e) => {
                                    if (e.target.checked) {
                                        var devanLocation = "";
                                        if (this.state.cartonDetail.sort_key === "UNKNOWN") {
                                            devanLocation = this.state.cartonDetail.exceptions_location
                                        }
                                        else {
                                            devanLocation = this.state.cartonDetail.unshippables_location;
                                            this.setState({ unshippableSelected: "UNSHIPPABLE" });
                                        }
                                        this.setState({ cartonState: "UNSHIPPABLE", expectedDevanLocation: devanLocation });
                                        this.refs.devanLocationScanInput.focus();
                                    }
                                }}
                            />}
                        </Col>
                        <Col>
                        </Col>

                    </Row>
                    {this.state.visibleCartonAsUOTCheckBox && <Row className="mt-2" >
                        <Col className="col-4">
                        </Col>
                        <Col>
                            {this.state.cartonDetail !== null && this.state.cartonDetail.sort_key !== 'UNKNOWN' && <Form.Check className="m-2" type='checkbox' id='uotctn' label='Carton Is UOT'
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ devanLocationScan: this.state.SSCC, cartonAsUOT: true, expectedDevanLocation: this.state.SSCC });
                                        setTimeout(() => {
                                            this.devanCarton();
                                        }, 500);
                                    }
                                    else {
                                        this.refs.devanLocationScanInput.focus();
                                        this.setState({ devanLocationScan: "", cartonAsUOT: false, expectedDevanLocation: this.state.cartonDetail.devan_location });
                                    }
                                }}
                            />}
                        </Col>
                    </Row>}
                    <Row className="mt-2">
                        <Col className="col-4">
                            Devan To:
                        </Col>
                        <Col className="col-8">
                            {this.state.expectedDevanLocation}
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            Scan Tote:
                        </Col>
                        <Col className="col-6">
                            <input className="form-control" type="text" placeholder="Scan location barcode..." autoFocus="autofocus"
                                value={this.state.devanLocationScan} onKeyPress={handleDevanLocationScan} disabled={this.state.disableDevanScanLocation}
                                ref="devanLocationScanInput"
                                onChange={(e) => {
                                    this.setState({ devanLocationScan: e.target.value });
                                }}
                                onInput={toInputUppercase} />

                        </Col>
                        <Col className="col-2">
                            <div className="p-1" style={{ backgroundColor: this.state.devanCartonScanResultColor, width: '65px', color: 'white' }}>{this.state.devanCartonScanResult}</div>
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col className="col-4">
                            <Button className="" variant="danger" disabled={this.state.loading} onClick={() => this.exitform()}>Exit</Button>
                        </Col>
                        <Col className="col-8">
                            <Button className="col-8" variant="warning" disabled={this.state.loading} onClick={() => this.setState({ alertCompleteDevanning: true })}>Devan Complete</Button>
                        </Col>
                    </Row>

                    <ModalYesNoWithComment title="Unknown Carton" show={this.state.alertAddUkCartonToShipment} message={this.state.SSCC + " is not on this shipment.  Add to shipment?"} onClickNo={(e) => { this.refs.ssccBarcodeScanInput.focus(); this.resetCartonScan(); }} onClickYes={(e) => { this.updateUnknownCartonComment(e) }} comment='hello'></ModalYesNoWithComment>
                    <ModalOK title={this.state.scanMessageTitle} show={this.state.showScanMessage} message={this.state.scanMessage} onClickOk={() => { this.hideOkAlert() }}  ></ModalOK>
                    <ModalYesNo title="Complete Devanning" show={this.state.alertCompleteDevanning} message="This will mark the shipment as receipted, any outstanding cartons will be marked as missing.  Continue?" onClickNo={(e) => { this.setState({ alertCompleteDevanning: false }) }} onClickYes={() => { this.completeDevan() }}></ModalYesNo>
                    {this.state.cartonDetail !== null && <ModalYesNo title="New tote location?" show={this.state.alertDevanToWithScanToteCompare} message={this.state.alertDevanToWithScanToteCompareMsg} onClickNo={(e) => { this.setState({ alertDevanToWithScanToteCompare: false, alertDevanToWithScanToteCompareMsg: '' }); this.refs.devanLocationScanInput.select(); }} onClickYes={() => { this.newToteLocation(); }}></ModalYesNo>}
                    <ModalYesNo title="Reset this form?" show={this.state.alertResetForm} message="Are you sure you want to reset?" onClickNo={(e) => { this.setState({ alertResetForm: false }); this.resetNoAction() }} onClickYes={() => { this.setState({ alertResetForm: false }); this.resetCartonScan(); }}></ModalYesNo>
                    <ModalYesNo title="Exit" show={this.state.alertExitForm} message="Are you sure you want to exit?" onClickNo={(e) => { this.setState({ alertExitForm: false }) }} onClickYes={() => { this.setState({ alertExitForm: false }); this.goto('CartonisedChooseShipment', null); }}></ModalYesNo>
                    <ModalOK title='Devan Error' show={this.state.devanErrorAlertFlag} message={this.state.devanErrorAlertMessage} onClickOk={() => { this.devanCartonAlertErrorHide() }}  ></ModalOK>
                </>
            </>
        );
    }

    updateUnknownCartonComment(note) {
        this.setState({ alertAddUkCartonToShipment: false, unknownCartonComment: note });
    }

    resetNoAction() {
        var check = this.refs.ssccBarcodeScanInput.disabled;
        if (check) {
            setTimeout(() => {
                this.refs.devanLocationScanInput.focus();
            }, 500);
        }
        else {
            setTimeout(() => {
                this.refs.ssccBarcodeScanInput.focus();
            }, 500);
        }
    }

    exitform() {
        if (this.state.SSCC.length > 0) {
            this.setState({ alertExitForm: true });
        }
        else {
            this.goto('CartonisedChooseShipment', null)
        }
    }

    newToteLocation() {
        this.setState({ alertDevanToWithScanToteCompare: false, isNewToteLocation: true });
        setTimeout(() => {
            this.devanCarton();
        }, 500);
    }

    compareDevanToWithScanTote() {
        if (this.state.devanLocationScan.trim().toUpperCase() !== this.state.expectedDevanLocation.trim().toLocaleUpperCase()) {
            // validate devan location
            var scannedDevannedLocation = this.state.devanLocationScan.trim().toUpperCase();
            var regexInsensitive = new RegExp(/^SCS-\d+$/, 'i');
            if (!regexInsensitive.test(scannedDevannedLocation)) {
                MySound.play(MySound.Sound.stop);
                this.setState({ showScanMessage: true, scanMessageTitle: "Invalid tote label", scanMessage: scannedDevannedLocation + " is not a valid SCS tote label" });
                this.refs.devanLocationScanInput.select();
                return;
            }
            MySound.play(MySound.Sound.stop);
            var sortkey = this.state.cartonDetail.sort_key;
            if (this.state.cartonState === 'UNSHIPPABLE') {
                sortkey = 'UNSHIPPABLE';
            }
            this.setState({ alertDevanToWithScanToteCompare: true, alertDevanToWithScanToteCompareMsg: "Start a new tote for " + sortkey + "?" });
        }
        else {
            this.devanCarton();
        }
    }

    completeDevan() {
        this.goto('CartonisedSupervisorSignoff', { backUrl: 'CartonisedScanCarton', nextUrl: 'CartonisedUnknownCarton', selectedShipment: this.state.selectedShipment });
    }

    runScanCartonLogic() {
        var scanCartonDetail = this.state.cartonDetail;
        if (scanCartonDetail !== null) {
            var isXDoc = scanCartonDetail.is_xdoc == 1 ? true : false;
            this.setDevanOptions();
            MySound.play(MySound.Sound.next);
        }
        else {
            this.setState({ showScanMessage: true, scanMessageTitle: "Error", scanMessage: 'Unable to retrieve SSCCC details.' });
            MySound.play(MySound.Sound.stop);
        }
    }

    setDevanOptions() {
        var scanCartonDetail = this.state.cartonDetail;
        var isXDoc = scanCartonDetail.is_xdoc == 1 ? true : false;
        if (isXDoc) {
            this.setState({
                visibleCartonAsUOTCheckBox: false,
                visibleUnshippableCheckBox: true,
                visibleDamageCheckBox: false,
                disableSSCCInputScan: true,
                disableCartonState: false,
                disableDevanScanLocation: false,
                expectedDevanLocation: scanCartonDetail.devan_location
            });
            this.refs.devanLocationScanInput.focus();
        }
        else {
            this.setState({
                visibleCartonAsUOTCheckBox: true,
                visibleUnshippableCheckBox: false,
                visibleDamageCheckBox: true,
                disableSSCCInputScan: true,
                disableCartonState: false,
                disableDevanScanLocation: false,
                expectedDevanLocation: scanCartonDetail.devan_location
            });
            this.refs.devanLocationScanInput.focus();
        }
        if (this.state.cartonDetail.sort_key === "UNKNOWN") {

            MySound.play(MySound.Sound.stop);
            this.setState({ alertAddUkCartonToShipment: true, expectedDevanLocation: this.state.cartonDetail.exceptions_location });
        }
    }

    devanCarton() {
        if (this.state.cartonState === "") {
            this.showOkAlert("Scan Error", "Please select carton state!");
            MySound.play(MySound.Sound.stop);
            return;
        }

        if (!this.state.cartonAsUOT && this.state.devanLocationScan.length === 0) {
            this.showOkAlert("Scan Error", "Please scan correct destination location!");
            MySound.play(MySound.Sound.stop);
            return;
        }

        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ShipmentReference: this.state.selectedShipment.shipment_ref,
                Sort_Key: this.state.cartonDetail.sort_key,
                ExpectedDevanLocation: this.state.expectedDevanLocation,
                ScannedDevanLocation: this.state.devanLocationScan,
                CartonState: this.state.cartonState,
                LoggedInUser: MyGlobal.user,
                CartonId: this.state.cartonDetail.cic_id,
                SSCC: this.state.SSCC,
                CartonAsUOTFlag: this.state.cartonAsUOT,
                IsNewToteLocation: this.state.isNewToteLocation,
                UnknownCartonNote: this.state.unknownCartonComment
            })
        };

        fetch('api/CartonisedInwards/DevanCarton', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, alertMessage: "", devanCartonScanResultColor: 'green', devanCartonScanResult: 'SAVED' });
                        this.resetCartonScan();
                        MySound.play(MySound.Sound.next);
                    }
                    else {
                        this.setState({ loading: false, alertMessage: "", devanCartonScanResultColor: 'red', devanCartonScanResult: 'INVALID' });
                        this.refs.devanLocationScanInput.focus();
                        this.refs.devanLocationScanInput.select();
                        this.devanCartonAlertErrorShow(result.errorMessage);
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, SSCC: "" });
                this.refs.ssccBarcodeScanInput.focus();

            });
    }

    devanCartonAlertErrorShow(message) {
        this.setState({ devanErrorAlertFlag: true, devanErrorAlertMessage: message });
        MySound.play(MySound.Sound.stop);
    }

    devanCartonAlertErrorHide() {
        this.setState({ devanErrorAlertFlag: false, devanErrorAlertMessage: '' });
        this.refs.devanLocationScanInput.focus();
        this.refs.devanLocationScanInput.select();
    }

    showOkAlert(messageTitle, message) {
        this.setState({ showScanMessage: true, scanMessageTitle: messageTitle, scanMessage: message });
    }

    hideOkAlert() {
        this.setState({ showScanMessage: false, scanMessageTitle: "", scanMessage: "" });
    }

    resetCartonScan() {
        this.setState({
            SSCC: "",
            cartonDetail: null,
            cartonAsUOT: false,
            cartonState: "GOOD",
            devanLocationScan: "",
            expectedDevanLocation: "",
            alertAddUkCartonToShipment: false,
            unknownCarton: false,
            visibleUnshippableCheckBox: true,
            visibleCartonAsUOTCheckBox: false,
            visibleDamageCheckBox: true,
            disableDevanScanLocation: true,
            disableSSCCInputScan: false,
            disableCartonState: true,
            isNewToteLocation: false,
            unknownCartonComment: '',
            unshippableSelected:''
        });
        this.refs.chkGood.checked = true;
        setTimeout(() => {
            this.refs.ssccBarcodeScanInput.focus();
        }, 500);

    }

    async scanCarton() {
        if (this.state.SSCC.length == 0) {
            return;
        }
        this.setState({ loading: true });
        const submitRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Shipment: this.state.selectedShipment, SSCC: this.state.SSCC, cartonAsUOTFlag: this.state.cartonAsUOT })
        };
        fetch('api/CartonisedInwards/ScanSSCC', submitRequest)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, cartonDetail: result.data, alertMessage: "" });
                        this.runScanCartonLogic();
                    }
                    else {
                        //this.setState({ loading: false, alertMessage: result.errorMessage, SSCC: "" });
                        this.refs.ssccBarcodeScanInput.focus();
                        MySound.play(MySound.Sound.stop);
                        this.setState({ loading: false, showScanMessage: true, scanMessageTitle: "Scan error", scanMessage: result.errorMessage, SSCC: "" });

                        //this.scanCarton("Scan Error", result.errorMessage);
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error, SSCC: "" });
                this.refs.ssccBarcodeScanInput.focus();

            });

    }
}
export default CartonisedScanCarton;

